import * as tslib_1 from "tslib";
import ComposeStyles from './ComposeStyles';
import selectComposeFormatOption from '../actions/selectComposeFormatOption';
import selectShowRecipientWellOption from '../actions/selectShowRecipientWellOption';
import store from '../store/store';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var styles = require('./MessageFormatFull.scss');
var MessageFormatFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessageFormatFull, _super);
    function MessageFormatFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageFormatFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var showBcc = getFallbackValueIfNull(optionStore.showBcc, userOptions.AlwaysShowBcc);
        var showFrom = getFallbackValueIfNull(optionStore.showFrom, userOptions.AlwaysShowFrom);
        var messageFormat = getFallbackValueIfNull(optionStore.composeFormat, userOptions.ComposeMarkup);
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.showRecipientWellOptions },
                React.createElement(OptionDescription, null, strings.options_frombcc_description),
                React.createElement(OptionsCheckbox, { checked: showBcc, label: strings.options_format_showBcc, onChange: this.onShowBccChanged }),
                React.createElement(OptionsCheckbox, { checked: showFrom, label: strings.options_format_showFrom, onChange: this.onShowFromChanged })),
            React.createElement("div", { className: styles.formatDropDownDiv },
                React.createElement("span", null, strings.options_format_formatLabel_front),
                React.createElement(Dropdown, { selectedKey: messageFormat, options: [
                        {
                            key: 'Html',
                            text: strings.options_format_dropdown_html,
                        },
                        {
                            key: 'PlainText',
                            text: strings.options_format_dropdown_plaintext,
                        },
                    ], onChanged: this.onComposeFormatChanged }),
                React.createElement("span", null, strings.options_format_formatLabel_back)),
            React.createElement(ComposeStyles, null)));
    };
    MessageFormatFull.prototype.onShowBccChanged = function (ev, checked) {
        selectShowRecipientWellOption('showBcc', checked);
    };
    MessageFormatFull.prototype.onShowFromChanged = function (ev, checked) {
        selectShowRecipientWellOption('showFrom', checked);
    };
    MessageFormatFull.prototype.onComposeFormatChanged = function (option, index) {
        selectComposeFormatOption(option.key);
    };
    MessageFormatFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], MessageFormatFull);
    return MessageFormatFull;
}(React.Component));
export default MessageFormatFull;
//# sourceMappingURL=MessageFormatFull.js.map